<template>
    <div id="duixiang">
        <h5>{{  app ? app.app_name : ''  }}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="3" />
            </el-aside>
            <el-main>
                <el-button @click="show = 'addone' ">添加检查对象</el-button>
                <el-button @click="show = 'addbyduixiangku' ">通过对象库添加</el-button>
                <el-button @click="show = 'addmany' ">批量上传检查对象</el-button>
                <AddOne v-if="show == 'addone' " :group_id="group.group_id" />
                <AddByDuxiangku v-if="show == 'addbyduixiangku' " :app_id="app_id" from="jcdx"  />
                <AddMany v-if="show == 'addmany' " :group_id="group.group_id" from="yunjiancha" />
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import { Tag } from 'iview';
import SubMenu from './SubMenu.vue'
import DuixiangTable from '../yunduixiang/cell/DuixiangTable.vue'
import AddOne from '../yunduixiang/cell/AddOne.vue'
import AddMany from '../yunduixiang/cell/AddMany.vue'
import AddByDuxiangku from './cell/AddByDuxiangku.vue'
export default {
    components: {
        Tag,
        SubMenu,
        DuixiangTable,
        AddOne,
        AddMany,
        AddByDuxiangku
    },
    data() {
        return {

            group: {
                group_id: '',
            },

            app_id: '',
            show: 'addone',
            app: null
        }

    },
    created() {
        this.app_id = this.$route.params.app_id
        this.app = JSON.parse(localStorage.getItem(this.app_id))
        if (!this.app) { this.getApp() }
        this.group.group_id = this.app.jcdx_group_id
    },
    methods: {
        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.app = res
                this.group_id = this.app.jcry_group_id
            }).catch((err) => {
                //console.log(err);
            })
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>